import React from 'react';

function ProgressBar({ progress, timeRemaining }) {
  return (
    <div className="w-full max-w-xl mx-auto bg-white p-6 rounded-lg shadow-sm">
      <div className="mb-2 flex justify-between items-center">
        <span className="text-sm font-medium text-gray-700">Generating your design...</span>
        {timeRemaining !== null && (
          <span className="text-xs text-gray-500">
            Estimated time: {timeRemaining > 0 ? `${timeRemaining} seconds` : 'Finishing up...'}
          </span>
        )}
      </div>
      
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div 
          className="bg-blue-600 h-2 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
}

export { ProgressBar }; 